export const PopUpCloseIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.4375 8.48438C8.71875 8.20312 9.23438 8.20312 9.51562 8.48438L12 10.9688L14.4375 8.48438C14.7188 8.20312 15.2344 8.20312 15.5156 8.48438C15.7969 8.76562 15.7969 9.28125 15.5156 9.5625L13.0312 12L15.5156 14.4844C15.7969 14.7656 15.7969 15.2812 15.5156 15.5625C15.2344 15.8438 14.7188 15.8438 14.4375 15.5625L12 13.0781L9.51562 15.5625C9.23438 15.8438 8.71875 15.8438 8.4375 15.5625C8.15625 15.2812 8.15625 14.7656 8.4375 14.4844L10.9219 12L8.4375 9.5625C8.15625 9.28125 8.15625 8.76562 8.4375 8.48438ZM24 12C24 18.6562 18.6094 24 12 24C5.34375 24 0 18.6562 0 12C0 5.39062 5.34375 0 12 0C18.6094 0 24 5.39062 24 12ZM12 1.5C6.1875 1.5 1.5 6.23438 1.5 12C1.5 17.8125 6.1875 22.5 12 22.5C17.7656 22.5 22.5 17.8125 22.5 12C22.5 6.23438 17.7656 1.5 12 1.5Z"
        fill="#999999"
      />
    </svg>
  );
};

export const DropDownArrow = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <polyline points="6,9 12,15 18,9"></polyline>
  </svg>
);
